// "task_start_time": 1646755200, status = 1, task_start_time > now_time = 预售未开始
// "task_end_time": 1646927999, status = 1, task_start_time < now_time < task_end_time = 预售
// "plan_start_time": 1647705600,  status = 2, plan_start_time > now_time = 采购未开始
// "plan_end_time": 1648655999, status = 2, plan_start_time < now_time < plan_end_time = 采购中

export const preSaleStatus = {
  0: '预售待开始',
  1: '预售',
  2: '采购待开始',
  3: '采购中'
};

export const preSaleStatusText = {
  1: '预售',
  2: '采购'
};

export const preSaleStatusActionText = {
  1: '预订',
  2: '加入购物车',
  3: '预订转订单'
};

export const preSaleTip = {
  0: '预售开始',
  1: '预售结束',
  2: '采购开始',
  3: '采购结束'
};

export const preCountDownText = {
  0: '预售开始倒计时',
  1: '预售剩余时间',
  2: '采购开始倒计时',
  3: '采购剩余时间',
};

export function renderStatusTagInfo(pre_sale = {}) {
  const { status = 0, } = pre_sale;//状态: 1-预售 2-采购
  const statusFun = {
    1: () => {
      const { task_start_time, task_end_time, now_time } = pre_sale;
      if (task_start_time > now_time) {
        return {
          computedStatus: 0,
          countDownTime: task_start_time * 1000 - (now_time * 1000 - Date.now()),
          showTipTime: task_start_time * 1000
        };
      } else if ((task_start_time < now_time) && (now_time < task_end_time)) {
        return {
          computedStatus: 1,
          countDownTime: task_end_time * 1000 - (now_time * 1000 - Date.now()),
          showTipTime: task_end_time * 1000
        };
      }
    },
    2: () => {
      const { plan_start_time, plan_end_time, now_time } = pre_sale;
      if (plan_start_time > now_time) {
        return {
          computedStatus: 2,
          countDownTime: plan_start_time * 1000 - (now_time * 1000 - Date.now()),
          showTipTime: plan_start_time * 1000
        };
      } else if ((plan_start_time < now_time) && (now_time < plan_end_time)) {
        return {
          computedStatus: 3,
          countDownTime: plan_end_time * 1000 - (now_time * 1000 - Date.now()),
          showTipTime: plan_end_time * 1000
        };
      }
    }
  };
  return statusFun[status]?.() || {};
}